import { render, staticRenderFns } from "./CreateUpdateTrip.vue?vue&type=template&id=71bf74f0&scoped=true&"
import script from "./CreateUpdateTrip.vue?vue&type=script&lang=js&"
export * from "./CreateUpdateTrip.vue?vue&type=script&lang=js&"
import style0 from "./CreateUpdateTrip.vue?vue&type=style&index=0&id=71bf74f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bf74f0",
  null
  
)

export default component.exports